import { autobind } from 'frontools/decorators/Autobind';
import Template from 'frontools/data/Template';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import KeyCode from 'frontools/events/KeyCode';

export class Overlay extends AbstractDispatcher {

    public static   BEFORE_OPEN     : string    =   'before_open';
    public static   OPEN            : string    =   'open';
    public static   BEFORE_CLOSE    : string    =   'before_close';
    public static   CLOSE           : string    =   'close';

    private _isOpen             : boolean       = false;

    private _el                 : HTMLElement;
    private _elContentWrapper   : HTMLElement;
    private _elClose            : HTMLElement;

    private _scrollTop          : number;
    
    constructor(private _content:HTMLElement, private _options:OverlayOptions) {
            super();

            let template = new Template(document.getElementById(this._options.templateId),{})
            this._el = template.htmlAsDOM.firstElementChild as HTMLElement; 
            if (this._options.blackBackground) this._el.classList.add('black');
            if (this._options.customClasses) this._el.querySelector('.content').className += " "+this._options.customClasses;
            if (this._options.wrapperCustomClasses) this._el.className += " "+this._options.wrapperCustomClasses;
            this._elClose = this._el.querySelector(this._options.closeButtonSelector) as HTMLElement;
            this._elContentWrapper = this._el.querySelector(this._options.contentSelector) as HTMLElement;
            
            if (this._elClose) this._elClose.addEventListener('click', this.close);

            this._elContentWrapper.appendChild(this._content)

            if (this._options.autoOpen) this._open();

            document.addEventListener('keyup', this._onKeyUp);
    }

    @autobind
    private _onKeyUp(e) {
        if (e.keyCode === 27) {
            this.close();
        }
    }

    @autobind
    protected _open() {
        this.dispatch({type: Overlay.BEFORE_OPEN});
        document.body.appendChild(this._el);
        this._scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        Overlay.animateHamburgerClose(this._elClose, null);
        document.documentElement.classList.add('hide_overflow'); 
        TweenMax.set(this._el, {opacity: 1});
        TweenMax.to(this._el, 0.01, {opacity:1, 
            onComplete: function() {
                // setTimeout(() => {   // Timeout for Ipad issue
                // }, 100); 
                this._isOpen = true;
                this.dispatch({type: Overlay.OPEN});
            }.bind(this)
        });    
    }

    @autobind
    public close() {
        this.dispatch({type: Overlay.BEFORE_CLOSE});
           
        Overlay.animateHamburgerClose(this._elClose, function() {
            document.removeEventListener('keyup', this._onKeyUp);
            // console.log(this._scrollTop)
            TweenMax.set(this._el, {opacity: 0});
            document.documentElement.classList.remove('hide_overflow');
            document.body.scrollTop = this._scrollTop;  
            if (!document.body.scrollTop) document.documentElement.scrollTop = this._scrollTop; 
            TweenMax.to(this._elContentWrapper, 0.01, {opacity:0, 
                onComplete: function() {
                    
                    TweenMax.to(this._el, 0.2, {opacity:0, 
                        onComplete: function() {
                            if (document.body.contains(this._el)) document.body.removeChild(this._el);
                            this._isOpen = false;
                            this.dispatch({type: Overlay.CLOSE});
                        }.bind(this)
                    });    
                }.bind(this)
            }); 
        }.bind(this), true);
    }

    public get el() : HTMLElement {
        return this._el;
    }

    public get isOpen() : boolean {
        return this._isOpen;
    }

    public static animateHamburgerOpen(hamburger: HTMLElement, onComplete:Function, onReverse?:boolean) {
        var tl = new TimelineMax({
            paused: true,
            onComplete: onComplete
        });
        if (!onReverse) {
            tl.to(hamburger.querySelectorAll('.bread')[0], 0.2, {y:5, ease: Expo.easeOut})
              .to(hamburger.querySelectorAll('.bread')[1], 0.2, {y:-5, ease: Expo.easeOut},0)
              .to(hamburger, 0.2, {scale:0, ease: Expo.easeOut},0.1)
        } else {
            tl.to(hamburger, 0.2, {scale:1, ease: Expo.easeOut})
              .to(hamburger.querySelectorAll('.bread'), 0.2, {y:0, ease: Expo.easeOut}, 0.1)
        }
       tl.play();
    }

    public static animateHamburgerClose(hamburger: HTMLElement, onComplete:Function, onReverse?:boolean) {
        var tl = new TimelineMax({
            paused: true,
            onComplete: onComplete
        });
        if (!onReverse) {
            tl.set(hamburger.querySelectorAll('.bread')[0], {y: 5});
            tl.set(hamburger.querySelectorAll('.bread')[1], {y: -5});
            tl.set(hamburger, {scale: 0});
            tl.to(hamburger, 0.2, {scale:1, ease: Expo.easeOut})
              .to(hamburger.querySelector('.meat'), 0.2, {rotation:'-45deg', ease: Expo.easeOut}, '+=0.1')
              .staggerTo(hamburger.querySelectorAll('.bread'), 0.2, {rotation:'45deg', ease: Expo.easeOut},0,'-=0.2')
        } else {
            tl.staggerTo(hamburger.querySelectorAll('.bread'), 0.2, {rotation:'0deg', ease: Expo.easeOut},0)
              .to(hamburger.querySelector('.meat'), 0.2, {rotation:'0deg', ease: Expo.easeOut}, 0)
              .to(hamburger, 0.2, {scale:0, ease: Expo.easeOut},0.2)
        }
       tl.play();
    }

}

/**
 * Options class with default values
 */
export class OverlayOptions {
    private _autoOpen                 : boolean   =       true;
    private _blackBackground          : boolean   =       false;
    private _contentSelector          : string    =       '.content';
    private _customClasses            : string    =       '';
    private _wrapperCustomClasses            : string    =       '';
    private _closeButtonSelector      : string    =       '[data-hamburger]';
    private _templateId               : string    =       'overlay_template';

    public set autoOpen(autoOpen: boolean) {
        this._autoOpen = autoOpen;  
    }

    public set blackBackground(blackBackground: boolean) {
        this._blackBackground = blackBackground;  
    }

    public set contentSelector(contentSelector: string) {
        this._contentSelector = contentSelector;
    }

    public set templateId(templateId: string) {
        this._templateId = templateId;
    }

    public set customClasses(customClasses: string) {
        this._customClasses = customClasses;
    }

    public set wrapperCustomClasses(wrapperCustomClasses: string) {
        this._wrapperCustomClasses = wrapperCustomClasses;
    }

    public set closeButtonSelector(closeButtonSelector: string) {
        this._closeButtonSelector = closeButtonSelector;
    }

    public get templateId() : string {
        return this._templateId;
    }

    public get contentSelector() : string {
        return this._contentSelector;
    }

    public get closeButtonSelector() : string {
        return this._closeButtonSelector;
    }

    public get customClasses() : string {
        return this._customClasses;
    }

    public get wrapperCustomClasses() : string {
        return this._wrapperCustomClasses;
    }

    public get autoOpen() : boolean {
        return this._autoOpen;
    }

    public get blackBackground() : boolean {
        return this._blackBackground;
    }
}